import Offcanvas from "react-bootstrap/Offcanvas";
import { GrFormClose } from "react-icons/gr";
import { NavLink } from "react-router-dom";
import { AiOutlineCheck } from "react-icons/ai";
import React from "react";

const SortProduct = ({
  isMobile = false,
  open,
  setOpen,
  optionItem,
  setChooseItem,
  setSort,
  changeUrlParams,
  setActivePage,
  chooseitem,
}) => {
  return isMobile ? (
    <div>
      <Offcanvas
        className="ordering-box-mod"
        placement="bottom"
        show={open}
        onHide={() => setOpen(false)}
      >
        <Offcanvas.Body>
          <div className="ordering-box-mod-title d-flex align-items-center mb-4">
            <GrFormClose
              size={35}
              color="#3F4064"
              cursor="pointer"
              onClick={() => setOpen(false)}
            />
            <span className="pe-3">مرتب سازی بر اساس</span>
          </div>

          <div className="ordering-box-mod-content px-2">
            {optionItem.map((it, index) => (
              <div
                className="ordering-box-mod-content-item mb-3 pb-3"
                onClick={() => {
                  setChooseItem(index);
                  setSort(it.value);
                  changeUrlParams("sort", it.value);
                  setActivePage(1);
                }}
              >
                <NavLink className="ordering-box-mod-content-link">
                  {it.title}
                </NavLink>
                {chooseitem == index && (
                  <div index={index} className="checked-icon">
                    <AiOutlineCheck size={20} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  ) : (
    <div className="ordering-items-option me-2 flex-wrap">
      {optionItem.map(
        (item, index) =>
          item.value != "most_visited" && (
            <p
              index={index}
              className={`pd-l-12 ${
                chooseitem == index && "active-option"
              } text-start`}
              style={{ width: "fit-content" }}
              onClick={() => {
                setChooseItem(index);
                setSort(item.value);
                changeUrlParams("sort", item.value);
                setActivePage(1);
              }}
            >
              {item.title}
            </p>
          )
      )}
    </div>
  );
};

export default SortProduct;
